import { useContext } from 'react';
import { CookieConsentContext } from '@/contexts/CookieConsentContext';

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (context === undefined) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }

  const hasUserConsented = () => context.hasConsented === true;
  const hasUserDenied = () => context.hasConsented === false;
  const hasUserMadeChoice = () => context.hasConsented !== null;

  return {
    ...context,
    hasUserConsented,
    hasUserDenied,
    hasUserMadeChoice,
  };
};
